import React, { FC } from 'react';
import { FallbackProps } from 'react-error-boundary';
import constants from '../constants';
import { I18n } from '../i18n';
import { fontSize, weight, space, filledButton } from './styles';

export const SimpleErrorFallback: FC<FallbackProps> = ({ error, resetErrorBoundary }) => {
    return (
        <div role="alert">
            <h1
                css={`
                    ${fontSize.large};
                    ${weight.regular};
                    margin-bottom: ${space(3)};
                    color: ${constants.colors.pallet.error};
                `}
            >
                <I18n>generalError</I18n>
            </h1>
            <div
                css={`
                    color: #737373;
                    margin-bottom: ${space(3)};
                `}
            >
                {error && <I18n>{error.message}</I18n>}
            </div>
            <button
                css={`
                    ${filledButton}
                `}
                onClick={resetErrorBoundary}
            >
                <I18n>tryAgain</I18n>
            </button>
        </div>
    );
};
